import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import KendoDropDownHelper from '@/Utility/KendoDropDownHelper';
import LabelViewModelType from '@/ViewModels/Controls/LabelViewModel';
import Utilities from '@/Utility/Utilities';

/**
 *  Das ViewModel für die MultiSelectDropDownList
 */
export default class MultiSelectDropDownListViewModel extends ControlViewModel {

    private LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModelType>('LabelViewModel');

    /**
     * Die wählbaren Optionen
     */
    public data: KnockoutObservableArray<any> | KnockoutComputed<any[]>;

    /**
     * Der ausgewählte Wert
     * Entspricht bei komplexen Typen dem Wert des "dataValueField"
     */
    public values: KnockoutObservableArray<string> | KnockoutComputed<string[]>;

    /**
     * Das Feld, welches angezeigt wird
     */
    public dataTextField: string;

    /**
     * Das Feld, welches den Wert beinhaltet
     */
    public dataValueField: string;

    /**
     * Ein Template zur Formatierung des ausgewählten Objekts
     */
    public template: KnockoutObservable<any>;

    /**
     * Ein Template zur Formatierung der auswählbaren Objekte
     */
    public valueTemplate: KnockoutObservable<any>;

    /**
     * Wird aufgerufen, sobald ein Objekt hinzugefügt wird
     */
    public onAddedCallback: Function;

    /**
     * Wird aufgerufen, sobald ein Objekt entfernt wird
     */
    public onRemovedCallback: Function;

    /**
     * Wird aufgerufen, sobald das DropDown geöffnet wird
     */
    public onOpenCallback: Function;

    /**
     * Wird aufgerufen, sobald das DropDown geöffnet wird
     */
    public onCloseCallback: Function;

    public constructor(protected params: any) {
        super(params);

        this.data = this.createData();
        this.values = this.createValues();

        this.dataTextField = this.paramOrDefault(params.dataTextField, null);
        this.dataValueField = this.paramOrDefault(params.dataValueField, null);
        this.template = this.observableOrDefault(params.template, null);
        this.valueTemplate = this.observableOrDefault(params.valueTemplate, null);

        this.onAddedCallback = this.handlerOrDefault(params.onAdded);
        this.onRemovedCallback = this.handlerOrDefault(params.onRemoved);
        this.onOpenCallback = this.handlerOrDefault(params.onOpen, () => Utilities.resolveImmediately(true));
        this.onCloseCallback = this.handlerOrDefault(params.onClose);

        this.tooltip = new this.LabelViewModel({
            caption: KendoDropDownHelper.createComputedTooltip((params.tooltip ? params.tooltip.caption : ''), 
                this.data, this.values, this.dataTextField, this.dataValueField,
                (sub) => this.subscriptionCollection.push(sub))
        });
    }

    /**
     * Creates data observable 
     */
    protected createData(): KnockoutObservableArray<any> | KnockoutComputed<any[]> {
        return this.observableOrDefault(this.params.data, []) as KnockoutObservableArray<any>;
    }

    /**
     * Creates values observable
     */
    protected createValues(): KnockoutObservableArray<string> | KnockoutComputed<string[]> {
        return this.observableOrDefault(this.params.values, []) as KnockoutObservableArray<string>;
    }

    /**
     * Wird aufgerufen, sobald das selektierte Objekt gewechselt wird
     */
    public onChange(event) {
        const added = event.added;
        const removed = event.removed;

        if (added != null) {
            this.onAdded(added);
        }

        if (removed != null) {
            this.onRemoved(removed);
        }
    }

    /**
     * Wird aufgerufen, sobald ein Objekt hinzugefügt wird
     */
    public onAdded(added): any {
        return this.onAddedCallback(added);
    }

    /**
     * Wird aufgerufen, sobald ein Objekt entfernt wird
     */
    public onRemoved(removed): any {
        return this.onRemovedCallback(removed);
    }

    /**
     * Wird aufgerufen, sobald das DropDown geöffnet wird
     */
    public onOpen(): any {
        return this.onOpenCallback();
    }

    /**
     * Wird aufgerufen, sobald das DropDown geschlossen wird
     */
    public onClose(): any {
        return this.onCloseCallback();
    }

}

ComponentManager.setViewModel('MultiSelectDropDownListViewModel', MultiSelectDropDownListViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');